// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"74":"e650e796","144":"90a14099","154":"507cfd6d","394":"54212859","586":"7d7c1258","682":"0cfb716a"}[chunkId] + ".chunk.css";
};